// probably timing problem with lit: https://github.com/lit/lit/blob/7453e365000e6a289c139cf7e175a4742296333d/packages/reactive-element/src/css-tag.ts#L10
// if lit is loaded before style sheet it cannot handle CSSStyleSheets from AdornisCSS
import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY

import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import '@adornis/fonts/fontSrc/lato.js';
import '@adornis/fonts/fontSrc/maven-pro.js';
import '@adornis/fonts/fonts.js';

import { subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { AdornisRoleToContextsWrapper } from '@adornis/users/db/roleToContextsWrapper.js';
import { User } from '@dla/db/User.js';

import '@dla/db/index.js';

import './main-element.js';
import './theme/theme.js';
import './translations.js';

void subscribeCurrentUser(() => ({
  ...User.allFields,
  roles: AdornisRoleToContextsWrapper.allFields,
}));

// * the server sets the sessionID url param if the client connected via the lti protocol. The context connected to this sessionID should already be authenticated
const currentSessionID = localStorage.getItem('sessionID');
const urlSessionID = new URL(location.href).searchParams.get('sessionID');

if (urlSessionID) {
  console.log('Got URLSession', currentSessionID, urlSessionID);
  localStorage.setItem('sessionID', urlSessionID);
}

BaseQLClient.initDefault();
